import React from "react";
import { Alert, Button, Form, Upload } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";

const ExcelUploadSection = ({
  templateName,
  uploadProps,
  fileList,
  disableUpload,
  uploadError,
  importedData,
  downloadSampleExcel,
}) => {
  return (
    <>
      {/* Download sample + upload widget — only after a template is selected */}
      {templateName ? (
        <Form.Item label="Choose Excel File">
          <div className="d-flex flex-column" style={{ gap: 8 }}>
            <span className="d-flex align-items-center" style={{ gap: 8 }}>
              <Upload {...uploadProps} fileList={fileList} accept=".xlsx">
                <Button size={'middle'} disabled={!disableUpload} icon={<UploadOutlined />}>
                  Click to Select
                </Button>
              </Upload>
              <Button
                type="link"
                icon={<DownloadOutlined />}
                onClick={downloadSampleExcel}
                style={{ paddingLeft: 0 }}
              >
                Download Sample Excel File
              </Button>
            </span>

            {/* Inline validation error — shown instead of toast */}
            {uploadError && (
              <Alert
                type="error"
                showIcon
                message={uploadError}
                className="mt-2"
              />
            )}
          </div>
        </Form.Item>
      ) : (
        <Alert
          className="mb-3 mt-2"
          type="warning"
          showIcon
          message="Please select a template above to enable Excel upload."
        />
      )}

      {/* Total count + first-row preview once numbers are loaded */}
      {importedData[0]?.number && (
        <Form.Item label="Loaded Numbers">
          <p className="float-right">
            Total numbers loaded: <strong>{importedData.length}</strong>
          </p>
          <span>
            First row preview — 📱 <strong>{importedData[0]?.number}</strong>
          </span>
        </Form.Item>
      )}
    </>
  );
};

export default ExcelUploadSection;
